/**
 * Customer Form Service
 * @author PBirudukota
 * @description Used post the application form
 */
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Observable, Subject, BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class DocumentUploadService {

  constructor(private http: HttpClient) {
  }

  public searchValue(payload) {
    return this.http.post('/api/search', payload);
  }

  public searchCustomerNumber(payload) {
      return this.http.post('/api/search/existing', payload);
  }

  public uploadDocsStaged(file, body) {
    const formPayload = new FormData();
    formPayload.append('body', body);
    formPayload.append('file', file, body.DOC_NAME);
    return this.http.post('/api/stagedUpload', formPayload);
  }

  public uploadDocsLive(file, body) {
    const formPayload = new FormData();
    formPayload.append('body', body);
    formPayload.append('file', file, body.DOC_NAME);
    return this.http.post('/api/liveUpload', formPayload);
  }

  public addToTransferQueueStaged(payload) {
    return this.http.post('/api/stagedUpload/add', payload);
  }

  public addToTransferQueueLive(payload) {
    return this.http.post('/api/liveUpload/add', payload);
  }

}


//   private fileSubject = new BehaviorSubject<any>('');

//   sendFileData(data: object) {
//     this.fileSubject.next(data);
//   }
// }
